<template>
  <!-- Shared Team/Org mid-row: Snapshot | Today's attendance | Leave Balance -->
  <!-- Equal-height stretch applied via CSS at ≥992 only; stacks full-width ≤991 -->
  <b-row class="mb-0 team-action-row team-primary-row team-mid-row">
    <b-col xl="4" lg="4" md="12" class="mb-0 team-main-col team-leader-alerts-col">
      <team-leader-alerts-panel
        :panel-title="panelTitle"
        :pending-leave-count="pendingLeaveCount"
        :probation-ending="probationEnding"
        :probation-source-missing="probationSourceMissing"
        :leave-conflicts="leaveConflicts"
        :probation-alerts="probationAlerts"
        :frequent-regularization="frequentRegularization"
        :upcoming-leaves-next7="upcomingLeavesNext7"
        :birthdays-this-week="birthdaysThisWeek"
        :announcement-count="announcementCount"
        :team-members="teamMembers"
        :get-user-name="getUserName"
        :format-date="formatDate"
        :punch-filter-active="punchFilterActive"
        :download-loading="downloadLoading"
        @pending-leaves-click="$emit('pending-leaves-click')"
        @leave-click="$emit('leave-click', $event)"
        @announcements-click="$emit('announcements-click')"
        @apply-punch-filter="$emit('apply-punch-filter', $event)"
        @clear-punch-filter="$emit('clear-punch-filter')"
        @download-punch-data="$emit('download-punch-data', $event)"
      />
    </b-col>
    <b-col xl="4" lg="4" md="12" class="mb-0 pl-lg-1 team-main-col team-today-col">
      <team-today-attendance-panel
        ref="todayAttendancePanel"
        :present="present"
        :absent="absent"
        :wfh="wfh"
        :is-non-working-day="isNonWorkingDay"
        :non-working-label="nonWorkingLabel"
        :filter-active="filterActive"
      />
    </b-col>
    <b-col xl="4" lg="4" md="12" class="mb-0 pl-lg-1 team-main-col team-leave-balance-col">
      <team-leave-balance-panel
        :items="leaveBalanceItems"
        :get-user-name="getUserName"
        :round-to-half="roundToHalf"
        :on-leave-today-count="onLeaveTodayCount"
        :on-leave-today-ids="onLeaveTodayIds"
        @download="$emit('download-leave-balance')"
      />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import TeamLeaderAlertsPanel from './TeamLeaderAlertsPanel.vue'
import TeamTodayAttendancePanel from './TeamTodayAttendancePanel.vue'
import TeamLeaveBalancePanel from './TeamLeaveBalancePanel.vue'

export default {
  name: 'TeamMidRow',
  components: {
    BRow,
    BCol,
    TeamLeaderAlertsPanel,
    TeamTodayAttendancePanel,
    TeamLeaveBalancePanel,
  },
  props: {
    panelTitle: { type: String, default: 'Team snapshot' },
    pendingLeaveCount: { type: Number, default: 0 },
    probationEnding: { type: Array, default: () => [] },
    probationSourceMissing: { type: Boolean, default: false },
    leaveConflicts: { type: Array, default: () => [] },
    probationAlerts: { type: Array, default: () => [] },
    frequentRegularization: { type: Array, default: () => [] },
    upcomingLeavesNext7: { type: Array, default: () => [] },
    birthdaysThisWeek: { type: Array, default: () => [] },
    announcementCount: { type: Number, default: 0 },
    teamMembers: { type: Array, default: () => [] },
    getUserName: { type: Function, required: true },
    formatDate: { type: Function, required: true },
    punchFilterActive: { type: Boolean, default: false },
    downloadLoading: { type: Boolean, default: false },
    present: { type: Array, default: () => [] },
    absent: { type: Array, default: () => [] },
    wfh: { type: Array, default: () => [] },
    isNonWorkingDay: { type: Boolean, default: false },
    nonWorkingLabel: { type: String, default: '' },
    filterActive: { type: Boolean, default: false },
    leaveBalanceItems: { type: Array, default: () => [] },
    roundToHalf: { type: Function, required: true },
    onLeaveTodayCount: { type: Number, default: 0 },
    onLeaveTodayIds: { type: Array, default: () => [] },
  },
}
</script>
